import Image from "next/image";
import Link from "next/link";

const CtaBtn = ({
  link,
  name,
  customClass,
  svgIcon,
  callFunction,
  target = "_self",
  download, // New prop for download functionality
}) => {
  return (
    <>
      {link ? (
        <Link
          href={link ?? ""}
          className={`relative  z-10 flex items-center w-fit uppercase font-primary bg-black text-white p-3 lg:p-[1vw] 
        text-xs sm:text-sm lg:text-[0.85vw] overflow-hidden tracking-widest cta ease-in-out duration-500 !leading-[1] ${customClass ? customClass : ""
            }`}
          onClick={callFunction && callFunction}
          target={target}
          {...(download ? { download: true } : {})} // Conditionally add download attribute
        >
          {svgIcon && (
            <Image
              src={svgIcon}
              width={20}
              height={18}
              alt=""
              className="w-[20px] h-auto inline-block align-middle me-[10px]"
            />
          )}{" "}
          {name}
        </Link>
      ) : (
        <a
          href={link ?? ""}
          className={`relative z-10 table uppercase font-primary bg-black text-white p-3 lg:p-[1vw] 
        text-xs sm:text-sm lg:text-[0.938vw] overflow-hidden tracking-widest cta ease-in-out duration-500 !leading-[1] ${customClass ? customClass : ""
            }`}
          onClick={callFunction && callFunction}
          target={target}
          {...(download ? { download: true } : {})} // Conditionally add download attribute
        >
          {name}
        </a>
      )}
    </>
  );
};

export default CtaBtn;
